'use strict';

var defaultConfig = require('../runtime/config-nodejs.js');

var isMultiaddr = require('mafmt').IPFS.matches;

var promisify = require('promisify-es6');

function isValidMultiaddr(ma) {
  try {
    return isMultiaddr(ma);
  } catch (err) {
    return false;
  }
}

function invalidMultiaddrError(ma) {
  return new Error("".concat(ma, " is not a valid Multiaddr"));
}

module.exports = function bootstrap(self) {
  return {
    list: promisify(function (callback) {
      self._repo.config.get(function (err, config) {
        if (err) {
          return callback(err);
        }

        callback(null, {
          Peers: config.Bootstrap
        });
      });
    }),
    add: promisify(function (multiaddr, args, callback) {
      if (typeof args === 'function') {
        callback = args;
        args = {
          default: false
        };
      }

      if (multiaddr && !isValidMultiaddr(multiaddr)) {
        return setImmediate(function () {
          return callback(invalidMultiaddrError(multiaddr));
        });
      }

      self._repo.config.get(function (err, config) {
        if (err) {
          return callback(err);
        }

        if (args.default) {
          config.Bootstrap = defaultConfig().Bootstrap;
        } else if (multiaddr && config.Bootstrap.indexOf(multiaddr) === -1) {
          config.Bootstrap.push(multiaddr);
        }

        self._repo.config.set(config, function (err) {
          if (err) {
            return callback(err);
          }

          callback(null, {
            Peers: args.default ? defaultConfig().Bootstrap : [multiaddr]
          });
        });
      });
    }),
    rm: promisify(function (multiaddr, args, callback) {
      if (typeof args === 'function') {
        callback = args;
        args = {
          all: false
        };
      }

      if (multiaddr && !isValidMultiaddr(multiaddr)) {
        return setImmediate(function () {
          return callback(invalidMultiaddrError(multiaddr));
        });
      }

      self._repo.config.get(function (err, config) {
        if (err) {
          return callback(err);
        }

        if (args.all) {
          config.Bootstrap = [];
        } else {
          config.Bootstrap = config.Bootstrap.filter(function (mh) {
            return mh !== multiaddr;
          });
        }

        self._repo.config.set(config, function (err) {
          if (err) {
            return callback(err);
          }

          var res = [];

          if (!args.all && multiaddr) {
            res.push(multiaddr);
          }

          callback(null, {
            Peers: res
          });
        });
      });
    })
  };
};